import { lightTheme, MeetingProvider } from 'amazon-chime-sdk-component-library-react';
import React from 'react';
import { ThemeProvider } from 'styled-components';
import { createArray } from '../../utils/array';
import { SessionContext } from './session-provider';
import { Video } from './video';
import { VideoConfigProvider } from './video-config-provider';
export const FakeVideoComponent = ({ attendeesCount, layout, mobile = false }) => {
    const attendees = createArray(attendeesCount).map((_, index) => index.toString());
    const currentAttendeeId = '1';
    const sharingAttendeeId = '';
    const focusedAttendeeId = '2';
    return (React.createElement(ThemeProvider, { theme: lightTheme },
        React.createElement(SessionContext.Provider, { value: { attendees, currentAttendeeId, sharingAttendeeId, focusedAttendeeId } },
            React.createElement(MeetingProvider, null,
                React.createElement(VideoConfigProvider, { layout: layout, mobile: mobile, getParticipantName: () => 'Name Surname', texts: {} },
                    React.createElement(Video, null))))));
};
//# sourceMappingURL=fake-component.js.map